const initState = {
  sidebar: {
    properties: {
      id: '',
      first_name: '',
      last_name: '',
      date: '',
      time: '',
      className: '',
      email: '',
    },
  },
  customEmail: {
    show: false,
    fetching: false,
    error: false,
    data: [],
    errorMessages: [],
  },
  trash: {
    show: false,
    fetching: false,
    error: false,
    data: [],
    errorMessages: [],
  },
  teacher: {
    show: false,
    fetching: false,
    error: false,
    classroomId: '',
    data: [],
  },
  student: {
    show: false,
    fetching: false,
    error: false,
    data: [],
  },
  conventionEmail: {
    sending: false,
    sent: false,
    error: false,
  },
  teacherEmail: {
    updating: false,
    updated: false,
    error: false,
    errorMessages: [],
  },
  studentEmail: {
    updating: false,
    updated: false,
    error: false,
    errorMessages: [],
  },
  photoDelete: {
    pending: false,
    error: false,
  },
  unassignStudent: {
    pending: false,
    error: false,
  },
};

export default initState;



// WEBPACK FOOTER //
// ./src/containers/PhotosDragAndDropApp/initState.js